<template>
    <!-- <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition"> -->
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="#d98880">
                        <v-toolbar-title class="my-0 py-0">REGISTRAR NUEVO ACCIDENTE</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <!-- <v-btn icon dark @click="show = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn> -->
                    </v-toolbar>
                </v-card>
                <v-card color="#e6b0aa">
                    <v-data-table dense :headers="headers" :items="listadoaccidente" locale="es-ar" height="250"
                        fixed-header :items-per-page="200" hide-default-footer class="pa-0 ma-0"
                        :item-class="setRowStyle">
                        <template v-slot:item.nombre="{ item }">
                            <v-text-field dense v-model="item.nombre" class="font-class-name"></v-text-field>
                        </template>
                        <template v-slot:item.area="{ item }">
                            <v-select dense v-model="item.area" :items="listadoarea" item-text="area"
                                item-value="codgral" class="font-class-name"
                                @change="updateSectorOptions(item)"></v-select>
                        </template>
                        <template v-slot:item.sector="{ item }">
                            <v-select dense v-model="item.sector" :items="item.filteredSector" item-text="sector"
                                item-value="codgral" class="font-class-name"></v-select>
                        </template>
                        <template v-slot:item.accidente="{ item }">
                            <v-text-field dense v-model="item.accidente" class="font-class-name"></v-text-field>
                        </template>
                        <template v-slot:item.fecha="{ item }">
                            <v-text-field dense v-model="item.fecha" class="font-class-name"></v-text-field>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card color="#d98880" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
    <!-- </v-dialog> -->
</template>
<script>
import moment from "moment";
import axios from "../../axios-auth";
import readXlsFile from "read-excel-file";
import { escape } from "lodash";
export default {
    data: (vm) => ({
        deshabilitar: false,
        listadoaccidente: [{ nombre: "", area: "", sector: "", accidente: "", fecha: moment().format("DD/MM/YYYY") }],
        fecha: moment().format("DD/MM/YYYY"),
        nombre: "",
        area: "",
        sector: "",
        accidente: "",
        headers: [{
            text: "Nombre",
            align: "start",
            sortable: false,
            value: "nombre"
        },
        { text: "Área", value: "area", sortable: false },
        { text: "Sector", value: "sector", sortable: false },
        { text: "Descripción", value: "accidente", sortable: false },
        { text: "Fecha", value: "fecha", sortable: false },],
        listadoarea: [],
        listadosector: [],
        valid: false,
        lazy: false,
    }),
    computed: {

        show: {
            get() {

                this.cargararea();
                this.cargarsector();
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargararea() {
            let self = this;
            axios
                .get("/Icssa/ListadoArea?")
                .then((response) => {
                    self.listadoarea = response.data;
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        cargarsector() {
            let self = this;
            axios
                .get("/Icssa/ListadoSector?")
                .then((response) => {
                    self.listadosector = response.data;
                    //self.listadofuncion = [];
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },


        updateSectorOptions(item) {
            // Filtra los modelos basados en el tipo seleccionado
            item.filteredSector = this.listadosector.filter(sector => sector.area === item.area);
            //item.filteredModelos = this.listadomodelo.filter(modelo => modelo.producto === item.producto);
            console.log("area", item.area)
            // if (String(item.producto).trim() === "Obras") {
            //     this.mostrarobra = true;
            // }
            // Opcional: Puedes establecer un valor predeterminado si es necesario
            // item.modelo = item.filteredModelos.length > 0 ? item.filteredModelos[0].valor : null;
        },

        // updateFuncionOptions(item) {
        //     item.filteredFuncion = this.listadofuncion.filter(funcion => funcion.producto === item.producto && funcion.modelo === item.modelo);
        // },

        setRowStyle(item) {
            return 'style-1'
        },

        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Accidente",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var i = 0
                    this.listadoaccidente.forEach((element) => {
                        if (element.nombre != "" && element.nombre != null) {
                            this.nombre = element.nombre;
                            this.area = element.area;
                            this.sector = element.sector;
                            this.accidente = element.accidente;
                            this.fecha = element.fecha;
                        }
                    });
                    var datos = {
                        nombre: this.nombre,
                        area: this.area,
                        sector: this.sector,
                        descr: this.accidente,
                        fecha: this.fecha,

                    };

                    let self = this;
                    axios
                        .post("/Icssa/GuardarAccidente", datos)
                        .then((response) => {
                            //self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Accidente guardado con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 8000,
            });
        },

        vaciarListado() {
            this.listadoaccidente = [];
            this.deshabilitar = false;
            setTimeout(() => {
                this.$router.push({ name: "Main" });
            }, 5000);
        },
    },
};
</script>
